import { brand } from "@/brandVariables/getBandVariables";
import { ReactComponent as ErrorWarning } from "../assets/warning_triangle.svg";

export const RacingDisclaimer = () => {
  const disclaimerSymbol = {
    LOGITECH: <ErrorWarning />,
  };

  if (brand.disclaimer) {
    return (
      <div className="overview__disclaimer">
        {disclaimerSymbol[brand.client] || ""}
        <small ><p style={{ fontSize: "10px" }}>{brand.disclaimer}</p></small>
      </div>
    );
  }

  return <></>;
};
